import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "@/index.css";
import "./i18n";
import App from "@/App";

const rootElement = document.getElementById("root");

// If react-snap has pre-rendered the app, hydrate; otherwise perform a full client render.
if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
